<div *ngIf="loader else content"
    class="height-100 d-flex flex-direction-column justify-content-center align-items-center row-gap">
    <span class="text-danger">It will take some time to load a large file...</span>
    <div class="dot-pulse"></div>
</div>

<ng-template #content>
    <iframe *ngIf="url" [src]="url" width="100%" height="100%" type="application/pdf"></iframe>
</ng-template>